export enum ROUTES {
  root = '/',
  test = 'test',
  graph = 'graph',
  carpet = '/carpet',
  table = 'table',
  dashboard = '/dashboard',
  handbook = '/handbook',
  wells = 'wells',
  wellPadPreparation = 'wellPadPreparation',
  schedule = 'schedule',
  planning = 'planning',
  matching = 'matching',
  newWell = 'newWell',
  conflicts = 'conflicts',
  settings = '/settings',
  'settings/section' = '/settings/:section',
  'settings/section/subsection' = '/settings/:section/:subsection',
}
